/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-25 11:24:06
 * @LastEditTime: 2024-01-29 16:19:40
 * @Descripttion: file content
 */
/* eslint-disable func-style */
import {all, call} from 'redux-saga/effects'

import commSage from './commSaga'
import userSage from './userSage'
import homeworkSage from './homeworkSage'

function* rootSaga() {
	yield all([call(userSage), call(commSage), call(homeworkSage)])
}
export default rootSaga
